import React from 'react'
import { SiteSEO } from 'components/site'

const supportEmail = 'support@howxm.com'

const Privacy = () => {
  return (
    <main className="max-w-[960px] mx-auto">
      <SiteSEO
        title="隐私政策 - 浩客HowXM"
        description="浩客HowXM 体验管理平台隐私政策，说明我们如何收集、使用、存储和保护您的个人信息。"
      />
      <div>
        <h1 className="text-center">浩客隐私政策</h1>
        <p>【本次更新时间：2025年6月】</p>
        <p>尊敬的客户（在本政策中简称“您”）</p>
        <p>
          我们十分重视个人信息的保护，我们将通过浩客隐私政策（以下简称“本政策”）帮助您了解我们如何收集、使用、存储及处理您的个人信息以及保障您的个人权利。
        </p>
        <p>引言</p>
        <p>
          「浩客体验管理平台」（本政策中简称“本产品”或“浩客”）是一款由「西安数据如金信息科技有限公司」（在本政策中简称“我们”）自主研发和运营的客户体验管理平台产品。主要功能为：助客户在多渠道、多触点聆听和分析体验数据，行动闭环管理优化体验，为客户提供体验优化方案和决策。
        </p>
        <p>
          请您在使用本产品前，仔细阅读本政策。我们将在您勾选“同意”后为您提供服务。您勾选同意或您使用本产品的行为均将视为您授权并同意我们按照本政策的指引收集、保存、使用、存储等处理您提供的数据。基于新出台的法律法规要求或优化产品服务所必须，我们将对本政策进行调整，并以公告的方式予以公布；若您在本政策内容公告变更后继续使用本产品，表示您已充分阅读、理解并接受修改后的本政策内容，也将遵循修改后的本政策内容使用本产品；若您不同意新的政策内容，您可停止使用本产品。
        </p>
        <p>
          如果您因年龄、智力等因素而不具有完全民事行为能力，请在法定监护人或其他监护人（以下简称&quot;监护人&quot;）的陪同下阅读和判断是否同意本政策，并特别注意未成年人使用条款；如果您是中国大陆地区以外的用户，您订立或履行本协议还需要同时遵守您所属和/或所处国家或地区的法律。{' '}
        </p>
        <p>
          本政策与您所使用的我们的服务息息相关。我们希望您能够仔细阅读，并在需要时按照本政策的指引做出您认为适当的选择。本政策中涉及的相关技术词汇，我们尽量以通俗易懂、简明扼要的表述向您解释。为了使您充分理解本政策，与您的权益存在或可能存在重大关系的条款，我们已采用加粗字体提醒您注意。
        </p>
        <h3>一、本政策的适用范围</h3>
        <p>本政策适用于本产品及我们基于本产品提供的服务。</p>
        <p>
          <strong>
            本政策仅适用于本产品的注册用户。如果您为本产品注册用户的终端客户（包括正在或已经向本产品数据收集页面提交数据的个人），请您注意并知悉：您的数据收集方为本产品的用户，其可能是商家或品牌方等，我们仅为其提供产品与技术支持，您提交的数据将通过本产品提交给商家或品牌方。如您欲了解更多，请查看商家或品牌方的隐私政策。同时我们提示您，您在数据收集页面（包括但不限于调研表单等）主动填写的内容，一经提交后即归于数据收集方控制，您有权拒绝填写与服务无关或不必要的信息，当其要求您填写身份证号码、手机号码、银行账号、地理位置等敏感个人信息的，请您谨慎评估风险并积极行使相关法律规定的权利。您如果需要查看、修改和删除您通过本产品提交的数据，请联系数据收集方，或联系我们协助您处理。我们的联系方式为：「
            <a href={`mailto:${supportEmail}`}>{supportEmail}</a>」
          </strong>
        </p>
        <h3>二、定义</h3>
        <p>
          （一）您，在本政策中主要指我们的客户，即委托我们提供技术服务的企业或个人。在特定情形下，也可能包括终端用户，即在您的官网、微信小程序、APP上进行浏览、登录、点击、信息输入等行为的自然人或由自然人代表进行前述操作的企业或组织体等。
        </p>
        <p>
          （二）数据，是指我们为您提供服务中涉及的数据，在本政策中将根据上下文可能指您主动提供的数据、我们在为您服务过程中产生的数据、第三方向我们提供的与您相关的合法授权的数据，这些数据都将用于优化我们的产品向您提供的更优质的服务。
        </p>
        <p>
          （三）个人信息，是指以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。
        </p>
        <p>（四）个人信息的处理，是指包括个人信息的收集、存储、使用、加工、传输、提供、公开、删除等。</p>
        <p>
          （五）个人敏感信息，是指一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息。
        </p>
        <p>（六）去标识化，是指个人信息经过处理，使其在不借助额外信息的情况下无法识别特定自然人的过程。</p>
        <p>（七）匿名化，是指个人信息经过处理无法识别特定自然人且不能复原的过程。</p>
        <h3>三、我们如何收集、使用、储存您的个人信息</h3>
        <h4>（一）我们收集的数据：</h4>
        <ol>
          <li>
            注册信息：在您首次登陆浩客产品时，需先进行账户注册，您需要提供手机号、邮箱、公司名称信息，这是您登陆和使用本产品的必要条件。
          </li>
          <li>
            设备或软件信息：例如移动设备、网页浏览器、您或终端用户用于接入我们的服务使用的其他程序所提供的配置信息、IP地址和移动设备常用基本情况的信息，包括硬件型号、设备ID、操作系统类型、软件名称、设备识别码（如IDFA／OPENUDID／GUID）。
          </li>
          <li>
            设备所在位置相关信息。如果终端用户在安装及／或使用过程设备中拒绝收集此类信息的，我们并不会收集此类的信息。
          </li>
          <li>终端用户使用第三方商业接口服务时搜索和浏览的信息，例如使用的网页搜索词语、访问的社交媒体页面url地址。</li>
        </ol>
        <h4>（二）我们如何使用收集的数据</h4>
        <p>
          我们严格遵守法律法规的规定及与您的约定，将收集的信息用于以下用途。如根据业务及功能必要性确需改变信息收集和使用的目的，我们将再次向您进行说明，并征得您的同意：
        </p>
        <ol>
          <li>向您提供客户体验管理技术服务，并维护、改进、优化这些服务。</li>
          <li>
            在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全，并依法采取必要的记录、审计、分析、处置措施。
          </li>
          <li>
            您使用我们的服务时，我们可能使用您的信息向您的设备发送电子邮件、短信、新闻或推送通知。如您不希望收到这些信息，您可以按照我们向您发出的通知中所述指示，在设备上选择取消订阅。
          </li>
          <li>
            为提升服务质量，我们在对我们的服务进行评估时，该评估结果可能会援引从您委托服务中得到的部分数据，但这些数据在评估结果中皆以去标识化处理后的聚合性形式的展示且仅被用于评估目的。
          </li>
          <li>根据法律法规或监管要求向相关部门进行报告。</li>
        </ol>
        <h4>（三）我们如何储存收集的数据：</h4>
        <p>
          我们在中华人民共和国境内运营中收集和产生的数据将按照法律法规和国家标准规定存储于中国境内，不会向境外转移。
        </p>
        <p>
          我们将采用安全措施存储数据，数据的存储期限严格按照法律及相关法规规定，最低期限不少于 6
          个月，并在满足服务目的后的合理期限内予以删除或匿名化处理，除非需要延长保留期或受到法律的允许。
        </p>
        <h3>四、我们如何使用 Cookie 和同类技术：</h3>
        <p>
          Cookie
          和同类技术是互联网中的通用常用技术。当您或终端用户使用我们的相关服务时，我们可能会使用相关技术向您的设备发送一个或多个
          Cookie 或匿名标识符，以收集和存储您访问、使用我们网站或系统时的信息。例如，您的浏览器名称和版本、设备型号、IP
          地址、地理位置、填写时长和提交时间、微信OpenID。我们使用 Cookie
          和同类技术主要为了保障产品与服务的安全、高效运转，改善产品服务及用户体验。
        </p>
        <p>
          如果您或终端用户的浏览器或浏览器附加服务允许，您或终端用户可修改对Cookie 的接受程度或拒绝我们的
          Cookie或不填写、提交体验数据。大多数浏览器均为终端用户提供了清除浏览器缓存数据的功能，您或终端用户可以在浏览器设置功能中进行相应的数据清除操作。但请注意，如果停用
          Cookie，您或终端用户可能无法享受相对更佳的服务体验。
        </p>
        <h3>五、我们如何共享、转让或公开披露收集的数据：</h3>
        <p>未经您的书面同意，我们不会与我们以外的任何公司、组织和个人共享、转让或公开您的数据，但以下情况除外：</p>
        <p>
          （一）因合并、分立、解散、被宣告破产等原因需要转移个人信息的，我们会向您告知接收方的名称或者姓名和联系方式。接收方会继续履行个人信息处理者的义务。接收方如果变更原先的处理目的、处理方式的，会重新取得您的同意。
        </p>
        <p>
          （二）为了实现您委托我们提供服务的目的，我们会和具体产品运营方的关联公司共享，我们只会共享必要的数据并按法律法规及本政策的要求进行管理。关联公司如要改变数据的处理目的，我们将再次征求您的授权同意。我们会与关联公司约定处理数据的目的、范围、处理方式，数据安全保护措施等，并明确关联公司的数据安全责任义务，并对其数据处理活动进行监督。
        </p>
        <h3>六、我们高度重视数据安全保障：</h3>
        <h4>（一）数据技术服务的合规性</h4>
        <p>
          数据的安全与合规管理是我们非常重视的工作，我们遵守法律法规的要求，采取较高的行业标准并实施更为高等级的安全及加密策略。
          我们根据用户数据收集相关的法律法规、采用业内通行的，合理的标准进行数据收集，使用不低于行业同行的加密技术、匿名化处理等合理可行的手段保护我们所收集的数据的安全性和保密性。
          我们建立了完善的数据安全管理体系，从组织建设、制度设计、人员管理、产品技术等方面多维度提升整个系统的安全性。
        </p>
        <p>
          与此同时，您在使用我们的产品和服务时，如在特定合作场景下需收集终端用户数据的，您应确保在您的平台上以第三方的形式向终端用户披露我们及我们的产品或服务并取得其授权。您理解并同意，我们基于合规性的要求，会不定期对您平台的披露情况进行审查，如发现未披露或未披露充分且在与您协商后仍未合规披露的，我们将会采取暂停或中止服务的措施以保证我们的合作符合数据网络安全法规及规范。
        </p>
        <h4>（二）安全技术和程序</h4>
        <p>我们采用了多种安全技术和程序，以防您或终端用户的数据的丢失、不当使用、未经授权阅览或披露，包括但不限于：</p>
        <ol>
          <li>
            技术措施：我们根据用户数据收集相关的法律法规，采用业内通行的、合理的标准进行数据收集，使用不低于行业同行的加密技术、匿名化处理等合理可行的手段保护我们所收集的数据的安全性和保密性；我们使用了多种安全技术和程序，包括但不限于防火墙和数据备份措施，以防止您的数据遭到意外丢失、损毁、不当使用、未经授权的访问或披露；此外，我们还切实采取了脱敏技术，对移动终端的识别性信息进行脱敏。
          </li>
          <li>
            制度与组织措施：除在我们的信息系统中建立的访问权限制度外，我们要求雇员签署严格的保密协议，并通过统一实施的数据安全管理制度加强内部管理。
          </li>
        </ol>
        <h4>（三）信息安全事件的应对</h4>
        <p>
          在可能或已发生个人信息安全事件时，我们将按照法律法规的要求向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、个人自主防范和降低风险的建议、补救措施等。事件相关情况我们将以邮件、信函、电话、推送通知等方式告知您或您的终端用户；或者我们会采取合理、有效的方式发布公告。亦请您将我们告知的情况同步告知您的终端用户。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。
        </p>
        <h4>（四）您的理解与协助</h4>
        <p>
          请您使用复杂密码，协助我们保证您的账号安全。我们将尽力保障您发送给我们的任何信息的安全性。但请您谅解，由于技术的限制以及风险防范的局限，即便我们已经尽量加强安全措施，也无法始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的情况而发生问题。请您妥善保护您及终端用户的数据，仅在必要的情形下向他人提供。如您发现您的账户或密码或您的数据发生任何泄露，请您立即联系我们，以便我们根据您的申请采取相应协助措施。
        </p>
        <h3>七、您的权利</h3>
        <p>
          在您使用本产品期间，您可以对您提供的账户信息进行操作，如访问、更正或注销账号，您可在个人中心注销账号，并且即刻生效。如果您无法通过上述方式访问、更正或删除您的个人信息，或您需要访问、更正或删除您在使用我们服务时所产生的个人信息，或您认为我们存在任何违反法规或您关于个人信息的收集使用约定，您均可以与我们联系。
        </p>
        <h3>八、未成年人信息的保护</h3>
        <p>
          &nbsp;&nbsp;（一）我们非常重视未成年人的个人信息保护。我们向企业级客户提供数据技术服务，我们不接受任何未成年人注册成为我们的用户，也不会主动收集未成年人的个人信息。受制于现有技术和业务模式，我们很难主动识别未成年人的信息，如果未成年人的监护人发现存在未经授权而收集未成年人个人信息，监护人可通知我们予以删除，如我们自己发现前述情形，我们也会主动予以删除。
        </p>
        <p>
          &nbsp;&nbsp;（二）如涉及您使用本产品可能收集到未成年人个人信息的，请您注意：(1)
          请您关注未成年人是否是在取得监护人的授权同意之后使用您的服务。(2)
          对于经父母或其他监护人同意使用我们的产品或服务而收集未成年人信息的情况，我们只会在法律法规允许、父母或其他监护人明确同意或者保护未成年人所必要的情况下根据您的授权委托收集、使用、共享、转让或披露此信息。
        </p>
        <h3>九、本政策的适用及更新</h3>
        <p>本产品所有服务均适用本政策。</p>
        <p>
          若发生公司变更、对您的信息收集及使用目的变更、您的管理方式变更、投诉机制及联络方式变更等发生重大变化情形时，我们会适时对本政策进行更新，并通过不同渠道向您发送变更通知，包括但不限于网站公示、私信通知、推送等方式。
        </p>
        <h3>十、联系我们</h3>
        <p>
          如果您有任何问题、建议或投诉，请与我们联系，联系方式为电子邮箱「
          <a href={`mailto:${supportEmail}`}>{supportEmail}</a>」。
        </p>
        <p>
          我们将尽快审核所涉问题，并在验证您的用户身份后的24小时内予以回复。
          「西安数据如金信息科技有限公司」对其发布的政策享有版权，受各国版权法及国际版权公约的保护。对于上述版权内容，超越合理使用范畴、并未经本公司书面许可的使用行为，西安数据如金信息科技有限公司均保留追究法律责任的权利。
        </p>
        <h3>附录：X-SDK Android 个人信息处理与信息公示</h3>
        <p>
          为满足 SDK
          信息公示相关要求，特就本公司向企业客户提供的移动端数据采集组件作如下专项说明。本附录适用于您在自有移动应用中集成
          X-SDK Android 的情形。
        </p>
        <h4>（一）SDK 基本信息</h4>
        <ol>
          <li>SDK 名称：X-SDK Android。</li>
          <li>开发者：西安数据如金信息科技有限公司。</li>
          <li>Android 包名：com.howxm.knowhow.sdk。</li>
          <li>SDK 类型：特定工具类，用于在终端用户侧展示问卷／体验反馈活动并跟踪相关事件。</li>
          <li>
            相关链接：官网 <a href="https://howxm.com">https://howxm.com</a>；下载页{' '}
            <a href="https://howxm.com/help/articles/x-sdk-andriod">https://howxm.com/help/articles/x-sdk-andriod</a>
            ；合规使用说明见{' '}
            <a href="https://howxm.com/help/articles/x-sdk-app-compliance">X-SDK Android 合规使用说明</a>。
          </li>
        </ol>
        <h4>（二）X-SDK Android 处理的个人信息种类与目的</h4>
        <ol>
          <li>
            客户端标识（clientId）：X-SDK Android
            初始化时通过随机算法（UUID）在本地生成的字符串，用于在不依赖任何设备硬件标识的前提下区分客户端、控制活动去重与触发。该标识不由设备硬件信息派生，您也可在初始化时自行指定。
          </li>
          <li>宿主应用包名、X-SDK Android 版本号：随请求头传输，用于服务鉴权与版本兼容性判断。</li>
          <li>
            您主动传入的用户信息：当您在应用中调用 X-SDK Android 的用户识别或活动展示能力并主动传入用户信息时，X-SDK
            Android
            将处理您传入的用户标识（uid）以及您选择传入的姓名、邮箱、手机号、自定义属性，用于关联并向对应用户展示反馈活动。是否传入及传入范围由您决定。
          </li>
          <li>标准网络信息：为保障通信与服务安全，服务器会记录访问请求的 IP 地址、User-Agent。</li>
        </ol>
        <p>
          上述处理的目的仅限于：向终端用户展示问卷／体验反馈活动、控制活动的触发与去重、关联与回收用户反馈，以及保障服务安全与正常运行。
        </p>
        <h4>（三）X-SDK Android 不收集的信息与权限边界</h4>
        <p>
          X-SDK Android <strong>不收集</strong> IMEI、MAC 地址、Android ID、IDFA、OAID 等设备标识符，
          <strong>不</strong>
          读取通讯录、短信、地理位置、相机、麦克风等敏感信息；仅申请 INTERNET 与 ACCESS_NETWORK_STATE
          两项权限；不在后台常驻运行，不具备热更新或自升级能力，<strong>不向任何第三方共享</strong>个人信息。
        </p>
        <h4>（四）接入方（企业客户）的合规义务</h4>
        <p>
          您在自有应用中集成 X-SDK Android 时，应在您的应用隐私政策中以第三方 SDK 的形式披露 X-SDK Android
          的名称、开发者及其处理的个人信息种类与目的，并在取得终端用户同意后再初始化 X-SDK
          Android。具体披露范本与接入要求详见《X-SDK Android 合规使用说明》。
        </p>
        <p>@2026 HOWXM, All Rights Reserved, HOWXM CONFIDENTIAL.</p>
      </div>
    </main>
  )
}

export const getStaticProps = async () => {
  return {
    props: {
      pageTitle: '隐私政策',
    },
  }
}

export default Privacy
